module.exports = __webpack_public_path__ + "img/27.a2040690.png";